import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import IconGlobe from '../Icon/IconGlobe'
import LayoutCol from '../Layout/LayoutCol'
import LayoutRow from '../Layout/LayoutRow'
import UIButton from '../UI/UIButton'
import UIButtonIcon from '../UI/UIButtonIcon'
import UIButtonMenu from '../UI/UIButtonMenu'
import UILogo from '../UI/UILogo'
import { css, StyleSheet } from 'aphrodite'
import { WIDTH } from '../../lib/helpers'
import { BP_XS } from '../../lib/breakpoints'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const WidgetMakerHeader = ({
  handleGlobeClick,
  isBecomeMakerButton = false,
  handleBecomeMakerClick,
  dynamicStyle,
  loginPage = false,
}) => {
  const { t } = useTranslation('translation')
  const handleMenuClick = () => {}
  if (isBecomeMakerButton) {
    return (
      <LayoutRow dynamicStyle={dynamicStyle ? css(dynamicStyle) : null}>
        {loginPage ? (
          <UILogo logoWithTextWhite={true} whiteLogo={true} />
        ) : (
          <UILogo />
        )}
        <LayoutCol>
          <LayoutRow justifyEnd>
            <UIButton
              label={t('common.header.becomeMaker')}
              onClick={handleBecomeMakerClick}
              kind="text"
              type="text"
              design="simpleText"
            />
            <UIButtonIcon onClick={handleGlobeClick}>
              <IconGlobe />
            </UIButtonIcon>
            <UIButtonMenu onClick={handleMenuClick} />
          </LayoutRow>
        </LayoutCol>
      </LayoutRow>
    )
  } else {
    return (
      <LayoutRow dynamicStyle={dynamicStyle ? css(dynamicStyle.custom) : null}>
        {loginPage ? (
          <UILogo whiteLogo />
        ) : (
          <div className={css(styles.div)}>
            <UILogo logoStyle={styles.bigLogo} />
          </div>
        )}
        <LayoutCol>
          {false && (
            <LayoutRow justifyEnd>
              <UIButtonIcon onClick={handleGlobeClick}>
                <IconGlobe />
              </UIButtonIcon>
              <UIButtonMenu onClick={handleMenuClick} />
            </LayoutRow>
          )}
        </LayoutCol>
        {false && WIDTH > BP_XS && (
          <LayoutCol>
            <LayoutRow justifyEnd>
              <UIButtonIcon onClick={handleGlobeClick}>
                <IconGlobe />
              </UIButtonIcon>
              <UIButtonMenu onClick={handleMenuClick} />
            </LayoutRow>
          </LayoutCol>
        )}
      </LayoutRow>
    )
  }
}

WidgetMakerHeader.propTypes = {
  handleBecomeMakerClick: PropTypes.func,
  handleGlobeClick: PropTypes.func,
  isBecomeMakerButton: PropTypes.bool,
  dynamicStyle: PropTypes.object,
  loginPage: PropTypes.bool,
}

const styles = StyleSheet.create({
  div: {
    position: 'auto',
    marginLeft: 20,
  },
  bigLogo: {
    width: 78,
    [MEDIA_MIN_SM]: {
      width: 200,
    },
  },
})

export default WidgetMakerHeader
